
import { defineComponent, onMounted, onUnmounted } from "vue";
import MainNavBar from "./components/navbar/MainNavBar.vue";
import { initAnimation } from "./Background";

export default defineComponent({
  name: "App",
  components: { MainNavBar },
  setup() {
    let cleanup: (() => void) | undefined;

    onMounted(() => {
      const canvas = document.getElementById(
        "background-canvas"
      ) as HTMLCanvasElement | null;
      if (canvas) cleanup = initAnimation(canvas);
    });

    onUnmounted(() => cleanup?.());
  },
});
